export const tableHeaders = [
  "Material",
  "Truck Type",
  "Quantity",
  "Material Cost",
  "Material Price",
  "Trucking Cost",
  "Trucking Price",
  "Landed Price",
];
